import React from 'react'
import { Result, Button, Space, message } from 'antd'
import { ToolOutlined } from '@ant-design/icons'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import moment from 'moment'
import Head from '../components/layout/head'
import { finishMaintenance } from '../actions'
import { getRolename } from '../lib/AuthUtils'
import { ROLES } from '../constants/AuthConstants'

class Maintenance extends React.Component {
  componentDidUpdate(prevProps) {
    const { finishingMaintenance, finishMaintenanceError, t } = this.props

    // Maintenance finished successfully
    if (prevProps.finishingMaintenance && !finishingMaintenance && !finishMaintenanceError) {
      message.success(t('Maintenance stopped successfully'))
      setTimeout(() => {
        window.location.href = '/'
      }, 1000)
    }

    // Error finishing maintenance
    if (prevProps.finishingMaintenance && !finishingMaintenance && finishMaintenanceError) {
      message.error(t('Error stopping maintenance'))
    }
  }

  handleBackHome = () => {
    window.location.href = '/'
  }

  handleStopMaintenance = () => {
    this.props.finishMaintenance()
  }

  formatEndDate = () => {
    const { maintenanceInfo } = this.props

    if (!maintenanceInfo?.endDate) {
      return null
    }

    const endDate = moment(maintenanceInfo.endDate)
    return endDate.format('DD/MM/YYYY HH:mm')
  }

  render() {
    const { t, auth, finishingMaintenance } = this.props
    const endDateFormatted = this.formatEndDate()
    const isAdmin = getRolename(auth) === ROLES.ADMIN

    return (
      <div
        style={{
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#f0f2f5',
        }}
      >
        <Head title={t('System Maintenance')} />
        <Result
          icon={<ToolOutlined />}
          title={t('System Under Maintenance')}
          subTitle={
            <div>
              <p>{t('We are performing scheduled maintenance')}</p>
              {endDateFormatted && (
                <p>
                  {t('Estimated end time')}: <strong>{endDateFormatted}</strong>
                </p>
              )}
              <p>{t('We apologize for any inconvenience. Please try again later.')}</p>
            </div>
          }
          extra={
            <Space direction='vertical'>
              <Button type='primary' onClick={this.handleBackHome}>
                {t('Try Again')}
              </Button>
              {isAdmin && (
                <Button danger onClick={this.handleStopMaintenance} loading={finishingMaintenance}>
                  {t('Stop Maintenance')}
                </Button>
              )}
            </Space>
          }
        />
      </div>
    )
  }
}

const mapStateToProps = ({ common, auth }) => ({
  maintenanceInfo: common.maintenanceInfo,
  auth,
  finishingMaintenance: common.finishingMaintenance,
  finishMaintenanceError: common.finishMaintenanceError,
})

export default connect(mapStateToProps, { finishMaintenance })(withTranslation()(Maintenance))
